var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 65,
    viewBox: "0 0 95 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.307 36.2729C90.2651 34.4135 92.8288 31.1737 93.195 27.7649C93.8711 21.7079 90.575 17.1158 86.3773 15.031C81.3627 12.5237 84.7152 14.3267 65.5017 8.35421C56.2612 5.48064 55.6696 2.80428 55.895 0.888565C53.3876 2.83245 52.627 13.3407 56.9655 16.496C61.4167 19.7358 70.2628 20.4119 81.3908 24.1588C91.1666 27.3986 89.7016 33.4557 87.307 36.2729Z",
    fill: "url(#paint0_linear_25192_5173)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2715 38.0764C88.4263 37.4847 87.4967 36.9776 86.5106 36.6114C72.5935 32.8363 71.354 32.9208 66.7619 31.5967C54.1689 27.9907 55.6902 24.9763 55.3803 23.7649C53.0702 26.6948 53.0138 35.8226 57.3242 38.5835C62.536 41.9078 71.7202 43.0065 83.3553 46.4153C87.1304 47.5422 89.356 48.8663 91.0182 50.4158C92.8494 52.1625 93.3565 54.7262 91.9479 56.8672C90.7083 58.7548 87.4121 58.4449 83.7779 57.8251C77.2983 56.7546 69.1002 54.529 66.7901 53.7965C56.4227 50.4158 55.7184 47.176 55.4085 45.9646C53.0983 48.8945 53.042 58.0223 57.3524 60.755C60.7612 62.9243 64.001 64.192 71.0159 64.671C76.1432 65.0372 85.4964 65.3753 90.0603 59.769C90.5111 59.2337 94.0608 56.0503 94.7933 50.5567C95.4412 45.4857 93.0748 40.7246 89.2715 38.0764Z",
    fill: "url(#paint1_linear_25192_5173)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3097 34.4697C82.4792 35.5403 86.5078 36.639 86.5078 36.639C86.5641 36.6672 86.6486 36.6954 86.705 36.7235C86.9022 36.5827 87.0994 36.4418 87.2966 36.3009C89.6912 33.4837 91.1562 27.4267 81.3523 24.1305C80.6761 23.9052 80 23.6798 79.352 23.4826C82.1129 24.7785 85.9725 31.9061 78.3097 34.4697Z",
    fill: "url(#paint2_linear_25192_5173)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8743 56.6417C80.6771 56.8108 80.5081 56.9798 80.2827 57.1207C81.4378 57.4024 82.621 57.6278 83.7197 57.7968C87.3821 58.3884 90.6783 58.6983 91.8897 56.839C93.2983 54.6979 92.7912 52.1342 90.96 50.3875C87.9174 47.4858 83.9733 46.5279 79.9728 45.4292C82.9309 47.035 85.3819 52.3877 80.8743 56.6417Z",
    fill: "url(#paint3_linear_25192_5173)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.064 16.2988C32.261 12.0447 29.162 8.35418 25.894 7.81891C20.0624 6.86105 15.7239 11.6503 13.7236 17.7637C11.329 25.0603 13.0475 20.1865 7.41304 48.0207C4.7085 61.4025 2.14483 62.2759 0.285461 61.9941C2.14483 65.6002 12.2305 66.6426 15.2168 60.3602C18.3157 53.9087 18.9073 41.0903 22.4288 24.9476C25.556 10.777 31.3594 12.8336 34.064 16.2988Z",
    fill: "url(#paint4_linear_25192_5173)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7561 13.4252C35.1926 14.6648 34.7137 15.9889 34.3756 17.4257C30.8259 37.597 30.9104 39.3719 29.6709 46.0487C26.262 64.2761 23.3884 62.1069 22.2334 62.5858C25.0506 65.9383 33.8122 65.9383 36.404 59.684C39.5593 52.1057 40.5453 38.8366 43.7851 21.9614C44.8275 16.4678 46.0953 13.2562 47.5884 10.8615C49.2506 8.18517 51.7016 7.4527 53.7581 9.4811C55.5611 11.2559 55.2794 16.0171 54.716 21.3134C53.73 30.6948 51.6452 42.5835 50.9409 45.936C47.7574 60.9518 44.6585 61.9942 43.5034 62.4731C46.3207 65.8256 55.0822 65.8256 57.6741 59.5714C59.7306 54.613 60.9139 49.9364 61.3646 39.7663C61.6745 32.3288 61.9562 18.8061 56.5753 12.2138C56.0401 11.5658 52.9975 6.4385 47.7293 5.39612C42.8273 4.46644 38.2916 7.93163 35.7561 13.4252Z",
    fill: "url(#paint5_linear_25192_5173)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3666 29.2862C33.3527 23.2573 34.395 17.4257 34.395 17.4257C34.4232 17.313 34.4514 17.2285 34.4795 17.1439C34.3387 16.8622 34.226 16.5805 34.0851 16.2988C31.3524 12.8336 25.5771 10.777 22.4782 24.9477C22.2528 25.9337 22.0556 26.8915 21.8584 27.8494C23.0698 23.8771 29.8593 18.2145 32.3666 29.2862Z",
    fill: "url(#paint6_linear_25192_5173)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.612 25.4552C53.7811 25.7369 53.9501 25.9904 54.091 26.3003C54.3445 24.61 54.5699 22.9197 54.7389 21.342C55.3024 16.0456 55.5841 11.2845 53.7811 9.50968C51.7245 7.48128 49.2735 8.21376 47.6113 10.8901C44.8505 15.3132 43.949 21.0321 42.9348 26.8074C44.3997 22.5534 49.4707 18.9756 53.612 25.4552Z",
    fill: "url(#paint7_linear_25192_5173)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25192_5173",
    x1: 105.833,
    y1: 22.1051,
    x2: 47.1108,
    y2: 16.0593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#4CE5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#076266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25192_5173",
    x1: 53.8196,
    y1: 44.3052,
    x2: 94.9003,
    y2: 44.3052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25192_5173",
    x1: 84.3667,
    y1: 28.5761,
    x2: 76.6052,
    y2: 38.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25192_5173",
    x1: 86.4355,
    y1: 49.8156,
    x2: 81.4631,
    y2: 66.6598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25192_5173",
    x1: 21.948,
    y1: -9.71209,
    x2: 13.7289,
    y2: 73.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#4CE5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#076266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25192_5173",
    x1: 41.9127,
    y1: 64.7785,
    x2: 41.6428,
    y2: 5.28778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25192_5173",
    x1: 26.3528,
    y1: 20.7027,
    x2: 38.1341,
    y2: 29.9293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#0D777F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#118590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25192_5173",
    x1: 47.2857,
    y1: 17.6021,
    x2: 64.4372,
    y2: 22.5785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMb);
export default __webpack_public_path__ + "static/media/logo-mb.c76eb0d0d132ab70b853606ac1b36eb4.svg";
export { ForwardRef as ReactComponent };